import React from 'react';

import moment from 'moment';

import {
  ActionsRequisesDtoActionsRequisesEnum,
  DossierSummaryResponseDto,
} from 'lib_api/lib/api/gen/api';

import {
  ColumnProps,
  TableHeaderFunction,
} from 'components/WrappedComponents/Table/types';
import { buildActionsRequisesContent } from 'utils/actionsRequisesUtils';
import { classementEnumMapping } from 'utils/enumData';
import { DATE_FORMAT } from 'utils/formats';
import {
  buildImmatriculationContent,
  buildStatutContent,
} from 'utils/TableUtils';

import DashboardHeader from '../DashboardHeader/DashboardHeader';

import { JusticeSortOptions } from './types';

export function buildColumns(
  url: string,
  justiceActionsRequises: ActionsRequisesDtoActionsRequisesEnum[] | undefined,
): ColumnProps<DossierSummaryResponseDto, JusticeSortOptions>[] {
  return [
    {
      title: 'N° de Parquet',
      buildCellContent: data => data.ficheJudiciaire?.numeroParquet,
      sortedField: JusticeSortOptions.NUMERO_PARQUET,
    },
    {
      title: 'Immatriculation',
      buildCellContent: data => buildImmatriculationContent(url, data),
      sortedField: JusticeSortOptions.IMMATRICULATION,
    },
    {
      title: "Date d'entrée",
      buildCellContent: data =>
        data.ficheFourriere !== null &&
        data.ficheFourriere.dateMiseEnFourriere !== null
          ? moment(data.ficheFourriere.dateMiseEnFourriere).format(DATE_FORMAT)
          : null,
      sortedField: JusticeSortOptions.DATE_MISE_FOURRIERE,
    },
    {
      title: 'Nature',
      buildCellContent: data => data.computed?.brancheDto?.nature,
      sortedField: JusticeSortOptions.NATURE_MISE_EN_FOURRIERE,
    },
    {
      title: 'Statut',
      buildCellContent: buildStatutContent,
      sortedField: JusticeSortOptions.STATUT,
    },
    {
      title: 'Classement',
      buildCellContent: data =>
        data.traitement !== null && data.traitement.classement !== null
          ? classementEnumMapping[data.traitement.classement].label
          : null,
      sortedField: JusticeSortOptions.CLASSEMENT,
    },
    {
      title: 'Fourrière',
      buildCellContent: data => data.computed?.fourriereDto?.raisonSociale,
      sortedField: JusticeSortOptions.FOURRIERE,
    },
    {
      title: 'Décision',
      buildCellContent: data => data.sortieJustice?.decision,
      sortedField: JusticeSortOptions.DECISION,
    },
    {
      title: 'Sort véhicule',
      buildCellContent: data => data.sortieJustice?.sortFinal,
      sortedField: JusticeSortOptions.SORT_FINAL,
    },
    {
      title: 'Action requise',
      buildCellContent: data =>
        buildActionsRequisesContent(url, data, justiceActionsRequises),
      sortedField: JusticeSortOptions.ACTIONS_REQUISES,
    },
  ];
}

export const buildHeader: TableHeaderFunction<
  DossierSummaryResponseDto,
  unknown
> = (fetchedData, _selectedData, filter, setFilter, sort) => (
  <DashboardHeader
    totalResult={fetchedData?.total ?? 0}
    filter={filter}
    setFilter={setFilter}
    sort={sort}
  />
);
